import CtaBand from "@/components/feature/CtaBand";
import AboutHero from "./components/AboutHero";
import ClinicOverview from "./components/ClinicOverview";
import ServicesCategories from "./components/ServicesCategories";
import ApproachSection from "./components/ApproachSection";

export default function About() {
  return (
    <>
      <AboutHero />
      <ClinicOverview />
      <ServicesCategories />
      <ApproachSection />
      <div className="pt-4 md:pt-8">
        <CtaBand
          title="Questions About Our Services?"
          description="Contact Florida Family Clinic to ask about services, availability, and what to expect before you visit."
        />
      </div>
    </>
  );
}